import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import * as UserActions from '../actions/user'
import LoginInternal from '../components/LoginInternal'


const mapDispatchToProps = (dispatch) => {
    
    const setInitialLogin = () => {
      dispatch(UserActions.initialLogin(true));
    }
   
    const mfaAuthenticate = (code, redurl) => {
      return dispatch(UserActions.mfaAuthenticate(code, redurl));
    }
      
    return {
       mfaAuthenticate,
       setInitialLogin
    }
  }
  
  const mapStateToProps = (state) => { 
    
  
    return {
      
    }
  }

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginInternal))
